import $ from "jquery";
export function addSkills(skills) {
	$.each(skills, (key, value) => {
		const skillId = `skill${key.replace(/[ .]+/g, '')}`;
		$('#skills').append(`
			<div class='skillBox'>
				<div class='skillName'>
					${key}
				</div>
				<div class='skillGrade' id='${skillId}'>
					${value}
				</div>
			</div>
		`);
	});
	setTimeout(() => $.each(skills, (key, value) => {
		const skillId = `skill${key.replace(/[ .]+/g, '')}`;
		$(`#${skillId}`).css('width', `${10 * value}%`);
	}));
}